// @flow
import { Router } from 'Routes/nextRoutes';
import URI from 'urijs';
import { windowWrapper } from '@clubmed/utils';

import DynamicLinkUtil from 'Components/frameworks/dynamic-link/DynamicLinkUtil';

// TODO This was a curried function. It should be just redirectTo(uri: string): void
// tu m'etonnes
function redirectTo(currentUrl?: string) {
  return (uri: string, options?: { shallow: boolean }) => {
    if (typeof window !== 'undefined') {
      const dynamicLinkHelper = new DynamicLinkUtil(currentUrl || window.location.href, uri);
      if (dynamicLinkHelper.isExternalUrl()) {
        windowWrapper.setLocation(uri);
      } else {
        const objectUri = new URI(uri);

        // next/router is not happy if you only pass him the query parameters. So get the pathname
        // when not provided
        if (objectUri.pathname() === '') {
          objectUri.pathname(window.location.pathname);
        }

        const currentUri = new URI(window.location.href);
        if (currentUri.resource() !== objectUri.resource()) {
          // URI().resource() prevent domain name to be passed to the history
          // http://domain/foo -> /foo
          // /foo -> /foo
          if (options && options.shallow) {
            Router.shallowPushRoute(objectUri.resource());
          } else {
            Router.pushRoute(objectUri.resource(), undefined, options);
          }
        }
      }
    }
  };
}

export default {
  redirectTo,
};
